import { lazy } from 'react';

import AuthGuard from 'components/AuthGuard';
import DashboardLayout from 'layouts/DashboardLayout';

const error404 = {
  component: lazy(() => import('views/Errors/Error404')),
};

const dashboardRoutes = {
  path: '/',
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: '/company',
      permission: 'company.select.getCompany',
      component: lazy(() => import('views/Company/Edit')),
    },
    {
      exact: true,
      path: '/dashboard',
      permission: 'dashboard.select.listDashboard',
      component: lazy(() => import('views/Dashboard')),
    },
    {
      exact: true,
      path: '/developers',
      permission: 'developers.select.listDevelopers',
      component: lazy(() => import('views/Developers/List')),
    },
    {
      exact: true,
      path: '/finance/billing',
      permission: 'billing.select.listBilling',
      component: lazy(() => import('views/Billing/List')),
    },
    {
      exact: true,
      path: '/movements/transactions',
      permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/Transactions/List')),
    },
    {
      exact: true,
      path: '/movements/transactions/:transactionId',
      permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/Transactions/Details')),
    },
    {
      exact: true,
      path: '/movements/recurring_charges',
      permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/RecurringCharges/List')),
    },
    {
      exact: true,
      path: '/movements/recurring_charges/:chargeId',
      permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/RecurringCharges/Edit')),
    },
    {
      exact: true,
      path: '/notifications',
      permission: 'notifications.select.listNotifications',
      component: lazy(() => import('views/Notifications/List')),
    },
    {
      exact: true,
      path: '/payment_links',
      permission: 'payments.select.listLinks',
      component: lazy(() => import('views/PaymentLinks/List')),
    },
    {
      exact: true,
      path: '/payment_links/add',
      permission: 'payments.select.listLinks',
      component: lazy(() => import('views/PaymentLinks/Edit')),
    },
    {
      exact: true,
      path: '/people/:peopleId',
      permission: 'people.select.getPeople',
      component: lazy(() => import('views/People/Details')),
    },
    {
      exact: true,
      path: '/users',
      permission: 'users.select.listUsers',
      component: lazy(() => import('views/Users/List')),
    },
    {
      exact: true,
      path: '/users/add',
      permission: 'users.select.addUsers',
      component: lazy(() => import('views/Users/Edit')),
    },
    {
      exact: true,
      path: '/commerce',
      permission: 'commerce.select.listCommerce',
      component: lazy(() => import('views/Commerce/List')),
    },
    {
      exact: true,
      path: '/commerce/add',
      permission: 'commerce.select.addCommerce',
      component: lazy(() => import('views/Commerce/Add')),
    },
    {
      component: lazy(() => import('views/Reports/List')),
      exact: true,
      path: '/reports',
      permission: 'reports.select.listReports',
    },
    error404,
  ],
};

export default dashboardRoutes;
